import React from "react";
import AllClients from "../Client/Clients/AllClients";
import { Button, DropdownMenu, NewTab, PageTab } from "../../../components";
import Invoice from "./QuickBooks/Invoice";
import Clients from "./QuickBooks/Clients";
import InvoicePayment from "./QuickBooks/InvoicePayment";
import APInvoice from "./QuickBooks/APInvoice";
import APInvoicePayment from "./QuickBooks/APInvoicePayment";
import Timesheets from "./QuickBooks/Timesheets";
import { color } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Vendors from "./QuickBooks/Vendors";

export const DropDownoptionsquickbooks = [
  {
    label: "All Invoices",
    value: 0,
  },
  {
    label: "All Clients",
    value: 1,
  },
  {
    label: "All Invoice Payment",
    value: 2,
  },
  {
    label: "All AP Invoice",
    value: 3,
  },
  {
    label: "All Vendors",
    value: 4,
  },
  {
    label: "All AP Invoice Payment",
    value: 5,
  },
  {
    label: "All Timesheets",
    value: 6,
  },
];
const QuickBooks = ({ setActiveTab }) => {
  const { currentProfile, loading } = useSelector((state) => state.quickBooks);
  const navigate = useNavigate();
  const ClientMenus = [
    {
      title: "Invoice",
      page: (
        <Invoice
          dropdowns={DropDownoptionsquickbooks}
          setActiveTab={setActiveTab}
        />
      ),
      type: "main",
    },
    {
      title: "Clients",
      page: (
        <Clients
          dropdowns={DropDownoptionsquickbooks}
          setActiveTab={setActiveTab}
        />
      ),
      type: "main",
    },
    {
      title: "Invoice Payment",
      page: (
        <InvoicePayment
          dropdowns={DropDownoptionsquickbooks}
          setActiveTab={setActiveTab}
        />
      ),
      type: "main",
    },
    {
      title: "AP Invoice",
      page: (
        <APInvoice
          dropdowns={DropDownoptionsquickbooks}
          setActiveTab={setActiveTab}
        />
      ),
      type: "main",
    },
    {
      title: "Vendors",
      page: (
        <Vendors
          dropdowns={DropDownoptionsquickbooks}
          setActiveTab={setActiveTab}
        />
      ),
      type: "main",
    },
    {
      title: "AP Invoice Payment",
      page: (
        <APInvoicePayment
          dropdowns={DropDownoptionsquickbooks}
          setActiveTab={setActiveTab}
        />
      ),
      type: "main",
    },
    {
      title: "Timesheets",
      page: (
        <Timesheets
          dropdowns={DropDownoptionsquickbooks}
          setActiveTab={setActiveTab}
        />
      ),
      // disabled: true,
      type: "main",
    },
    // {
    //   title: "Tek Tree LLC",
    //   color: "info",
    //   type: "sub",
    //   //   icon: "add",
    // },
    // {
    //   title: "Import Invoices From QB",
    //   color: "info",
    //   type: "sub",
    //   link: "/quickbooks/payments-from-qb",
    // },
  ];
  return (
    <div className="flex flex-col gap-1 overflow-hidden">
      <div className="flex my-2 items-center justify-between">
        {/* <Button title="Tektree LLC " color="black"/> */}
        <Button
          color="black"
          title={"Back"}
          icon={"west"}
          type="link"
          to="/invoices"
          className="px-2! py-1!"
        />
        <div className="flex flex-end items-end justify-end gap-2">
          {currentProfile?.companyName && ( 
            <Button title={currentProfile?.companyName || ""} color="black" />
          )}
          <DropdownMenu
            MenuSection={
              <div className="flex flex-col">
                <Button
                  title={"Import Invoices From QB"}
                  variant="text"
                  color="black"
                  className="!justify-start py-1"
                  onClick={() => navigate("/quickbooks/invoices-from-qb")}
                />
                <Button
                  title={"Import Payment From QB"}
                  variant="text"
                  color="black"
                  className="!justify-start py-1"
                  onClick={() => navigate("/quickbooks/payments-from-qb")}
                />
                <Button
                  title={"Import AP Invoices From QB"}
                  variant="text"
                  color="black"
                  className="!justify-start py-1"
                  onClick={() => navigate("/quickbooks/ap-invoices-from-qb")}
                />
                <Button
                  title={"Import AP Payments From QB"}
                  variant="text"
                  color="black"
                  className="!justify-start py-1"
                  onClick={() => navigate("/quickbooks/ap-payments-from-qb")}
                />
                <Button
                  title={"Import Account Types From QB"}
                  variant="text"
                  color="black"
                  className="!justify-start py-1"
                  // onClick={()=>navigate("/quickbooks/account-types-from-qb")}
                />
              </div>
            }
          >
            <Button title={"Import From QB"} color="info" />
          </DropdownMenu>
        </div>
      </div>
      <NewTab
        tabs={ClientMenus}
        //    color="black"
        //    variant="text"
        color="black"
        variant="outlined"
        mode="url"
        tabId="quickbooks"
      />
    </div>
  );
};

export default QuickBooks;
